module.exports = __webpack_public_path__ + "img/fundermax-slider-2.1388fb46.jpg";